export const TestimonialCard = ({ quote, name, role, avatar }) => (
  <div
    data-testid={`testimonial-${name.replace(/\s+/g, "-").toLowerCase()}`}
    className="bg-white/5 border border-white/10 rounded-2xl p-6 sm:p-8 flex-shrink-0 w-full sm:w-[360px]"
  >
    <p className="text-clean-white/90 font-medium italic leading-relaxed mb-6">&ldquo;{quote}&rdquo;</p>
    <div className="flex items-center gap-3">
      <img src={avatar} alt={name} className="w-11 h-11 rounded-full object-cover" />
      <div>
        <p className="text-sm font-bold text-clean-white">{name}</p>
        <p className="text-xs text-stranger-orange font-bold tracking-wide uppercase">{role}</p>
      </div>
    </div>
  </div>
);
